import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import EditCollaboratorForm from "../../components/collaborators/EditCollaboratorForm";

export default function EditCollaborator() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate("/collaborators");
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Editar Permissões"
                description="Editar permissões do colaborador"
            />
            <PageBreadcrumb
                pageTitle="Editar Permissões"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditCollaboratorForm
                    collaboratorId={id}
                    onSuccess={() => {
                        navigate("/collaborators");
                    }}
                    onError={(error) => {
                        console.error("Erro ao editar permissões:", error);
                    }}
                />
            </div>
        </>
    );
}
